import(/* webpackMode: "eager" */ "/codebuild/output/src142463875/src/doctor-dashboard/app/global-error.tsx");
